(function (appSetup) {

	appSetup.coreFactory = function (app) {
		var core = {};

		core.updateHistory = function (action, path, queryParams) {

			app.router.writeHistory(action, path, queryParams);
		};

		core.initializePageData = function (pageData, queryParams, ignoreWriteHistory) {

			// first access check
			var accessGranted = app.utils.checkPageAccessForRole(pageData, app.role);

			if (!accessGranted) {
				console.log("access denied");
				core.handlers.onGoTo(app.constants.links.login);
				return;
			}
			if (!ignoreWriteHistory) {
				core.updateHistory("push", pageData.path, queryParams);
			}
			
			app.currentPage = pageData;

			app.currentController = app.components.getController(pageData.title);

			core.breadcrumbs.updateBreadcrumbs();

			core.events.dispatchEvent("pageDataInitialized");
			
			$(".cart-num").closest(".cart").removeClass("hide"); 
		};

		core.handlers = {
			onHistoryPopState: function (params) {
				var ignoreWriteHistory = true;
				var pageData = app.utils.findPageByPath(params.path);
				core.initializePageData(pageData, params.params, ignoreWriteHistory);
			},
			onGoBack: function () {
				app.router.goBack();
			},
			onSoftGoBack: function () {
				var pageData = app.prevPageData;
				var params = null;
				var ignoreWriteHistory = true;
				core.initializePageData(pageData, params, ignoreWriteHistory);
			},
			onGoTo: function (location) {
				app.router.goTo(location);
			},
			onSwitchToPage: function (pageData, params) {
				core.initializePageData(pageData, params);
			},
			onSoftSwitchToPage: function (pageData) {
				app.prevPageData = app.currentPage;
				var ignoreWriteHistory = true;
				var params = null;
				core.initializePageData(pageData, params, ignoreWriteHistory);
			},
			onSwitchToPath: function (path, params) {
				var pageData = app.utils.findPageByPath(path);
				core.initializePageData(pageData, params);
				
				// code added to fix 302 issue in IE 11.5 and below versions of IE .
				var previousURL=path;
				var ua = window.navigator.userAgent; //Check the userAgent property of the navigator object
				var msie = ua.indexOf('MSIE '); // IE 10 or older
				var ie11 = ua.indexOf('Trident/'); //IE 11
				
				if((msie > 0 || ie11 > 0) && previousURL=="/rmstorefront/rm/en/USD/")
					{
					location.reload();
					}
				//end for 302 error fix 
				
			},
			onUpdateQuery: function (action, queryData) {
				if (!queryData) return;
				var path = app.router.path;
				var queryParams = $.param(queryData, true);
				core.updateHistory(action, path, queryParams);
			}
		};

		core.events = {
			pageDataInitialized: {},
			controllerInitialized: {},
			layoutInitialized: {},
			b2bUnitChanged: {},
			appInitialized: {},
			quoteCreated: {},
			quoteDeleted: {},
			orderCreated: {},
			savedOrderDeleted: {},
			registerHandler: function (event, originName, fn) {
				if (this[event]) {
					this[event][originName] = fn;
				}
			},
			registerHandlerAsLastOne: function (event, originName, fn) {
				if (!this[event]._lastFns) {
					this[event]._lastFns = {};
				}
				this[event]._lastFns[originName] = fn;
			},
			dispatchEvent: function (event) {
				var eventObject = this[event];
				for (var fn in eventObject) {
					if (fn != "_lastFns") {
						eventObject[fn]();
					}
				}
				if (eventObject._lastFns) {
					var lastFns = eventObject._lastFns;
					for (var lastFn in lastFns) {
						lastFns[lastFn]();
					}
				}
			}
		};

		core.breadcrumbs = {
			list: [],
			updateBreadcrumbs: function () {
				if (this.list.length === 0 || this.list.length[this.list.length - 1] != app.currentPage.title) {
					this.list.push(app.currentPage.title);
				}
			},
			getPreviousPageTitle: function () {
				if ([0, 1].indexOf(this.list.length) > -1) return null;
				return this.list[this.list.length - 2];
			}
		};

		core.cache = {
			clear: function (storage) {
				if (storage) {
					window[storage].clear();
				} else {
					window.sessionStorage.clear();
					window.localStorage.clear();
				}
			},
			saveResponse: function (url, queryData, res, isSession) {
				if (!app.config.caching) return false;
				res.then(function (data) {
					try {
						if (data && data.status == 200) {
							delete queryData.CSRFToken;

							var key = {
								url: url,
								query: queryData,
								ver: app.ver
							};
							key = JSON.stringify(key);

							var storage = (isSession) ? sessionStorage : localStorage;
							storage.setItem(key, JSON.stringify(data));

							return true;
						} else {
							return false;
						}
					} catch (e) {
						console.log(e);
						return false;
					}
				});
			},
			getResponse: function (url, queryData, isSession) {
				if (!app.config.caching) return false;
				try {
					if (url && queryData.constructor === Object.prototype.constructor) {
						var key = {
							url: url,
							query: queryData,
							ver: app.ver
						};
						key = JSON.stringify(key);

						var storage = (isSession) ? sessionStorage : localStorage;

						var res = storage.getItem(key);

						if (res) {
							res = JSON.parse(res);
							return $.Deferred().resolve(res);
						} else {
							return false;
						}
					} else {
						return false;
					}
				} catch (e) {
					console.log(e);
					return false;
				}
			}
		};

		core.init = function () {

			app.role = new app.roleConstructor(app.config.user.role);

			app.router.init();

			app.components.getService("layout").init();

			core.events.dispatchEvent("appInitialized");

		};

		return core;
	};

	window.appSetup = appSetup;

})(window.appSetup || {});